import { Component, Vue, Ref } from "vue-property-decorator";
import LeftTree from '../components/LeftTree.vue'
import TimeAnalysisBody from './components/TimeAnalysisBody'
import './components/timeanalysis.less'
import { StatisticsServiceProxy,TimeAnalysisDTO } from '@/service-proxies/app-v2/mdc.service-proxies'
const stsp = new StatisticsServiceProxy()

enum map {
  SHIFT = 1,
  DAY,
  WEEK,
  MONTH
}

@Component({
  components: {
    LeftTree,
    TimeAnalysisBody
  }
})
export default class TimeAnalysis extends Vue {
  @Ref() timeAnalysisBody: TimeAnalysisBody
  operationData = []
  tabsdData = []
  columns = []
  loading = false
  searchValue = {}

  getTableList(value) {
    this.loading = true
    this.operationData = []
    const data = {
      date: value.date,
      shiftIndex: value.shiftIndex,
      statisticalMethod: map[value.statisticalMethod],
      workStationList: value.workStationList
    }

    stsp.timeAnalysisByWcs(data as any).then(res =>{
      let arr = [];  

      for(var i=0; i<data.workStationList.length; i++) {
        for(var j=0; j<res.items.length; j++) {
          if(data.workStationList[i].key == res.items[j].workStationId) {
            arr.push(res.items[j])
          }
        }
      }   

      this.columns = res.head
      // this.operationData = res.items
      this.operationData = arr
      this.loading = false
    })
  }

  search(value) {
    delete(value.productivityType)
    this.searchValue = {...value}
    stsp.splitFilter(value).then(res =>{
      this.tabsdData = (res.items).reverse()
      this.timeAnalysisBody.defaultActiveKey = 0
      if(res.items){
        this.getTableList(this.tabsdData[0])
      }
    })
  }

  handleChange(value){
    this.tabsdData.forEach((res,index) =>{
      if (index === value){
        this.getTableList(res)
      }
    })
  }

  outPut() {

  }

  changeX(){

  }

  leftTree() {
    return (
      <left-tree init={['statistical','shift','time','Tree.vue']} onSearch={value => this.search(value)} onOutPut={() => this.outPut()} queryKey="time-analysis"></left-tree>
    )
  }

  timeAnalysis() {
    return (
      this.operationData ? <time-analysis-body ref="timeAnalysisBody" searchValue={this.searchValue} loading={this.loading} tabsdData={this.tabsdData} data={this.operationData} columns={this.columns} onChangeTabs={value => this.handleChange(value)}></time-analysis-body> : null
    )
  }

  render() {
    return (
      <a-layout class="timeanalysis-body" style="height: 100%">
        <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          {this.leftTree()}
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ height: '100%' }}>
          {this.timeAnalysis()}
        </a-layout-content>
      </a-layout>
    )
  }
}
